import React from "react";
import classes from './errorMessages.css';

export const ErrorMessageGeneric = text => <p className={classes.ErrorMessageGeneric}>{text}</p>


// WEBPACK FOOTER //
// ./src/components/errorMessages/errorMessages.js